// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3bkvl","topBottomGutter":"Layout_topBottomGutter__2aWuI"};